import {
  REASON_EXIT_INTERVIEW_FETCHING,
  REASON_EXIT_INTERVIEW_FAILED,
  REASON_EXIT_INTERVIEW_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case REASON_EXIT_INTERVIEW_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case REASON_EXIT_INTERVIEW_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case REASON_EXIT_INTERVIEW_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
